module.exports = __webpack_public_path__ + "static/media/no_pets.d994fb68.svg";